import { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useStyles } from "./DropdownSecondaryCodeRequirements.styles";
import { useTranslation } from "react-i18next";
import { CSSProperties } from "@mui/styles";

export interface IOptionSecondaryCodes {
    id: number;
    name: string;
}

export const DropdownSecondaryCodeRequirements = ({
    disabled,
    inlineStyle,
    obligatory,
    options,
    optionSelected,
    handleUpdate,
}: {
    disabled?: boolean;
    options: IOptionSecondaryCodes[];
    optionSelected?: number;
    handleUpdate: (id: number) => Promise<void>;
    obligatory?: boolean;
    inlineStyle?: CSSProperties;
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [option, setOption] = useState(optionSelected ? String(optionSelected) : "");

    const handleChange = async (event: SelectChangeEvent) => {
        await handleUpdate(Number(event.target.value));
        setOption(event.target.value);
    };

    return (
        <div>
            <FormControl variant="standard">
                {!Boolean(option) && (
                    <InputLabel className={classes.labelStyle} id="demo-simple-select-standard-label">
                        {`${obligatory ? "* " : ""}${t("locations.secondary_code_requirements_table.pending")}`}
                    </InputLabel>
                )}
                <Select
                    disabled={disabled}
                    disableUnderline
                    id="demo-simple-select-standard"
                    value={option}
                    className={classes.select}
                    onChange={handleChange}
                    style={inlineStyle}
                >
                    {options.map((option) => (
                        <MenuItem key={option.id} className={classes.menuItem} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};
